import {v4 as uuidv4} from 'uuid';
import {DisplayAdVo} from '../../common/shared/api/gateway/DisplayAdVo.interface';
import {MyNewsVo} from '../../common/shared/api/nicolas/vo/MyNewsVo.interface';
import {MyNewsList} from '../generated/types';
import {createDisplayAd} from './DisplayAd';
import {createMyNewsItem} from './MyNewsItem';

export function createMyNewsList({
  news,
  display_ad,
}: {
  news?: MyNewsVo[];
  display_ad?: DisplayAdVo;
}): MyNewsList {
  return {
    id: uuidv4(),
    news: news ? news.map(createMyNewsItem) : [],
    displayAd: display_ad ? createDisplayAd(display_ad) : undefined,
  };
}
